import React, { useState, useRef, useEffect } from "react";
import "./TitledCheckedDropDown.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { useLanguage } from "../../context/Languagecontext";

const TitledCheckedDropDown = ({
  title,
  options,
  onSelectAll,
  onSelect,
  selectedValues,
  selections,
  selectClass,
  extraStyle
}) => {
  const { Globals } = useLanguage();
  const dropdownRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);
  const [isOpen, setIsOpen] = useState(false);
  let allElementsLength = selectedOptions?.length - 2
  const isAllSelected = options?.length > 0 && options?.every(opt => selectedOptions.includes(opt.name));
  

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
 
  const collapseDropdown = () => {
    setIsOpen(false);
  }
 
  const handleSelectedItems = (id, option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((opt) => opt !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
    onSelect(id);
  };
 
  const handleSelectAllItems = (e) => {
    if (e.target.checked) {
      setSelectedOptions(options.map(opt => opt.name));
      onSelectAll(true);
    } else {
      setSelectedOptions([]);
      onSelectAll(false);
    }
  };
 
  const getDisplayText = () => {
    if (selectedOptions?.length === 0) {
      return title;
    } else if (selectedOptions?.length <= 2) {
      return selectedOptions.join(', ');
    } else {
      return `${selectedOptions[0].name ? selectedOptions[0].name : selectedOptions[0]}, ${selectedOptions[1].name ? selectedOptions[1].name : selectedOptions[1]} + ${selectedOptions?.length - 2}`;
    }
  };
 
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
 
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 
  return (
    <div className={"titledCheckedDropdown "+selectClass || ""} ref={dropdownRef}>
      <div className="titledCheckedDropdown-title" onClick={toggleDropdown} onBlurCapture={collapseDropdown}>
        <div className={`title ${selectedOptions&&selectedOptions.length>0?"selected-items":""}`}>{getDisplayText()}</div>
        <div className="titledCheckedDropdown-img">
          <img className="titledCheckedDropdown-img" src={OldGlobals.IMG.DROPDOWN} alt="titledCheckedDropdown" />
        </div>
      </div>
      {isOpen && (
        <div className="titledCheckedDropdown-content">
          <div key={"Select-All"} id="selectall" className="titledCheckedDropdown-Item selectALL">
            <input
              type="checkbox"
              id=""
              value="SelectAll"
              className="filter_checkbox"
              checked={isAllSelected}
              onChange={handleSelectAllItems}
            />
            <label htmlFor="selectall" id="select-all-items" className="option-label-list">
              {Globals.CHECKDROPDOWN.SELECTALL}
            </label>
          </div>
 
          {options.map((option) => (
            <div key={option.id} className="titledCheckedDropdown-Item">
              <input
                type="checkbox"
                id={option.id}
                value={option.name}
                className="filter_checkbox"
                checked={selectedOptions.includes(option.name) || isAllSelected}
                onChange={() => handleSelectedItems(option.id, option.name)}
              // disabled={isAllSelected}
              />
              <label htmlFor={option.name} className="option-label-titled">
                {option.name}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
 
export default TitledCheckedDropDown;